/* unplugin-vue-components disabled */import { render } from "./LogicalQuestionEditor.vue?vue&type=template&id=5afd4ba2&scoped=true"
import script from "./LogicalQuestionEditor.vue?vue&type=script&lang=js"
export * from "./LogicalQuestionEditor.vue?vue&type=script&lang=js"

import "./LogicalQuestionEditor.vue?vue&type=style&index=0&id=5afd4ba2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5afd4ba2"]])

export default __exports__